// extracted by mini-css-extract-plugin
export default {"container":"phone-input_container__bG2Re","select":"phone-input_select__0ZfSM","flag":"phone-input_flag__xQMSt"};